import { useMemberExtract } from 'contexts/MemberExtract';
import React from 'react';
import { useTranslation } from 'react-i18next';

function ShowMore() {
  const { t } = useTranslation(['glossary']);

  const { isLastPage, showMore, loading } = useMemberExtract();

  if (isLastPage) {
    return null;
  }

  return (
    <button
      disabled={loading}
      onClick={showMore}
      className="corporate-club-extract__card__body__table__show-more"
      type="button"
    >
      {loading ? t('loading') : t('showMore')}
      {!loading && <span className="corporate-club-extract__card__body__table__show-more__icon" />}
    </button>
  );
}

export default ShowMore;
